import Route from 'cio/routes/base';
import { Authenticated2faSetupRouteModel } from 'cio/pods/authenticated/2fa-setup/route';

export default class Authenticated2faSetupIndex extends Route {
  model() {
    let { codes } = this.modelFor('authenticated.2fa_setup') as Authenticated2faSetupRouteModel;
    return codes;
  }
}
